'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.encrypt_cbc = encrypt_cbc;
exports.decrypt_cbc = decrypt_cbc;
exports.encrypt_cbc_withmac = encrypt_cbc_withmac;
exports.decrypt_cbc_withmac = decrypt_cbc_withmac;

var _asmcryptoAll = require('asmcrypto.js/asmcrypto.all.js');

var asmcrypto = _interopRequireWildcard(_asmcryptoAll);

var _sjcl = require('sjcl');

var _sjcl2 = _interopRequireDefault(_sjcl);

var _hmac_sha = require('./hmac_sha256');

var _hmac_sha2 = _interopRequireDefault(_hmac_sha);

var _Convertor = require('../Convertor');

var _Convertor2 = _interopRequireDefault(_Convertor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function encrypt_cbc(key, data) {
	var iv = _sjcl2.default.codec.bytes.fromBits(_sjcl2.default.random.randomWords(4)),
	    cipher = asmcrypto.AES_CBC.encrypt(data, key, undefined, Uint8Array.from(iv)),
	    ciphertext = _Convertor2.default.appendUint8Array(iv, cipher);

	// Return the cipher text in Uint8 Array
	return ciphertext;
}

function decrypt_cbc(key, data) {
	var iv = data.subarray(0, 16),
	    cipher = data.subarray(16),
	    decrypted = asmcrypto.AES_CBC.decrypt(cipher, key, undefined, iv);

	// outputs decrypted in Uint8 Array
	return decrypted;
}

function encrypt_cbc_withmac(key, data) {
	var aes_key = key.subarray(0, 32),
	    mac_key = key.subarray(32);

	var ciphertext = encrypt_cbc(aes_key, data);
	var mac = (0, _hmac_sha2.default)(mac_key, ciphertext);
	ciphertext = _Convertor2.default.appendUint8Array(ciphertext, mac);

	return ciphertext;
}

function decrypt_cbc_withmac(key, data) {
	var aes_key = key.subarray(0, 32),
	    mac_key = key.subarray(32),
	    mac = data.subarray(data.length - 32, data.length),
	    ciphertext = data.subarray(0, data.length - 32),
	    verifier = (0, _hmac_sha2.default)(mac_key, ciphertext);

	if (!_Convertor2.default.isArrayEqual(mac, verifier)) {
		return undefined;
	}

	return decrypt_cbc(aes_key, ciphertext);
}